import React from 'react';
import locationIcon from 'assets/img/location.png'; 
import taxiIcon from 'assets/img/taxi.png';
import arrowIcon from 'assets/img/arrow.png';
import { Space } from 'antd';
import { Link } from "react-router-dom";
import { MdLocationOn, MdArrowDownward  } from 'react-icons/md';

import { FaEye,FaRocketchat, FaStar,FaRegStar   } from 'react-icons/fa';
const CardTravel = (props) => {
  
  const { fecha, unidad, folio, desde, a,  tarifa,empresa,user_id, estatus, califa = 0,user_type = 1 } = props;
 
  const tarifaformat=parseFloat(tarifa).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
  return (
    <div className="bg-gray-50 shadow-lg rounded-lg p-4 max-w-sm mx-auto w-full">
      <div className="card-header flex justify-between items-center">
        <h2 className="text-lg "><strong>Fecha del viaje: </strong> {fecha}</h2>
        {estatus === 'ASIGNADO' && (
        <Link 
              className="flex items-center justify-center" 
              to={`/admin/trip/${folio}/${user_id}`}
              title="Ver detalle">
            <FaRocketchat   className="mr-2" />
              
          </Link>
        )}
      </div>
      <div className="border-t border-gray-300 my-2" />
      <div className="card-body">
        <p><strong># de unidad: </strong>{unidad}</p>
        <div className="flex justify-between items-center">
            <p><strong>Folio: </strong>{folio}</p>
            <Link 
              className="flex flex-col items-end" 
              to={`https://detalle.mitaxiaeropuerto.com/cliente/${folio}`}
              title="Ver detalle">
            <FaEye   className="mr-2" />
              
          </Link>
          
        </div>
        <div className="flex items-center my-2">
        <img src={locationIcon} alt="Ubicación" className="h-6 w-6 ml-2" />
          <span className="ml-2"><strong>De: </strong> {desde}</span>
        </div>
        <div className="flex flex-col  my-2 relative">
        <img src={arrowIcon} alt="Flecha hacia abajo" className="h-12 w-2 ml-4" />
        <img src={taxiIcon} alt="Taxi" className="h-5  absolute top-1/2 transform -translate-y-1/2" />
          <img src={arrowIcon} alt="Flecha hacia abajo" className=" h-12 w-2 ml-4" />
        </div>
        <div className="flex items-center my-2">
        <img src={locationIcon} alt="Ubicación" className="h-6 w-6 ml-2" />
          <span className="ml-2"><strong>a: </strong> {a}</span>
        </div>
        <div className="flex items-center mt-4 rounded-full bg-white justify-between">

            <Space size="middle">

                <Link
                  className="bg-orange-500 text-white py-2 px-4 rounded-full w-3/5"
                  to={`/admin/invoice/${tarifa}/${folio}/${empresa}`}
                >
                    <strong>VER FACTURA</strong>
                </Link>

            </Space>

            <div className="flex flex-col items-end">

                {
                  Number(califa) > 0 ? (

                    <div
                      className="flex items-center text-yellow-500 mb-1"
                      title={`Calificación: ${califa}`}
                    >

                      {[1,2,3,4,5].map((star) => (

                        star <= Number(califa)
                          ? <FaStar key={star} className="mr-1" />
                          : <FaRegStar key={star} className="mr-1" />

                      ))}

                    </div>

                  ) : (

                    <Link
                      className="flex items-center text-orange-500 hover:text-orange-600 mb-1"
                      to={`https://detalle.mitaxiaeropuerto.com/calificar/${folio}?origen=${
                              Number(user_type) === 2
                                ? 'operador'
                                : 'cliente'
                            }`}
                      title="Calificar viaje"
                    >

                      <FaRegStar className="mr-1" />

                      <span>Calificar</span>

                    </Link>

                  )
                }

                <span className="text-right ml-2 text-lg font-bold text-black rounded-full px-3 flex justify-content-end">
                    $ {tarifaformat}
                </span>

            </div>

        </div>
      </div>
    </div>
  );
};

export default CardTravel;
